module.exports = __webpack_public_path__ + "img/75594.8e4cbbed.svg";